import { FC } from 'react'
import { GridLinks } from '@lifedot/components/GridLinks'
import { Card } from '@lifedot/atoms/Card'
import { mq } from '@lifedot/styles/mediaQuery'
import { typography } from '@lifedot/styles/typography'
import { css } from '@emotion/react'
import { useFragment } from 'react-relay/hooks'
import { graphql } from 'relay-runtime'
import { StationLinksList_stations$key } from './__generated__/StationLinksList_stations.graphql'
import { useStationLinksItems } from './dependencies'
import { useListPage } from '@/hooks/use-list-page'

const styles = {
  root: css({
    padding: '12px 40px',
    [mq('sp')]: {
      padding: 12
    }
  })
}

interface StationLinksProps {
  stations: StationLinksList_stations$key
}

export const StationLinksList: FC<StationLinksProps> = ({ stations }) => {
  const data = useFragment(stationsFragment, stations)
  const items = useStationLinksItems(data)
  const { city, station } = useListPage()

  if (items.length < 1) return null

  return (
    <Card>
      <div css={styles.root}>
        <h2 css={typography.textM}>
          {city?.name
            ? `${city.name}にある駅から探す`
            : `${station?.railwayLineName}の駅一覧`}
        </h2>
        <GridLinks items={items} />
      </div>
    </Card>
  )
}

const stationsFragment = graphql`
  fragment StationLinksList_stations on StationWithCemeteryCountConnection {
    items {
      stationId: id
      isMain
      name
      cemeteryCount
    }
  }
`
